import { TagContainer } from './styles'

const Tag = ({ name, iconName}) => {

    var iconExists = true;

    try {
        var tmp = require(`react-icons/${iconName.substring(0, 2).toLowerCase()}`);
        var Icon = eval(`tmp.${iconName}`)
    } catch (e) {
        iconExists = false;
    }

    return (
        <TagContainer>
            { iconExists === true && <Icon /> }
            <span>{name}</span>
        </TagContainer>
    )
}

export default Tag
